module.exports = __webpack_public_path__ + "img/main.7d50ca5.png";